export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SCHOOL_API_BASE_URL = process.env.REACT_APP_SCHOOL_API_BASE_URL;
export const PARENT_COMPANY_ID = process.env.REACT_APP_PARENT_COMPANY_ID;
export const AI_BASE_URL = process.env.REACT_APP_AI_BASE_URL;
export const FIREBASE_MESSAGING_KEY = process.env.REACT_APP_VAPID_KEY;
export const BUILD_TYPE = process.env.REACT_APP_BUILD_TYPE;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
// Wellpoint Max/Min values
export const WELLPOINT_MAX = 200000;
export const WELLPOINT_MIN = 1000;
export const WELLPOINT_STEP = 1000;
export const DEFAULT_VALUE = 100000;
